import { __assign, __awaiter, __generator } from "tslib";
import { IconError, IconGreenCheck } from '@anex/common';
import axios from 'axios';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { createRef, useEffect, useState } from 'react';
import Recaptcha from 'react-google-invisible-recaptcha';
import InputMask from 'react-input-mask';
import { Alert } from '../../../../../components';
var recaptcha;
export var VoucherCode = inject('config', 'summaryStore', 'saleStore')(observer(function (props) {
    var _a = useState(''), token = _a[0], settoken = _a[1];
    var _b = useState(null), error = _b[0], seterror = _b[1];
    recaptcha = createRef();
    useEffect(function () {
        if (props.saleStore.voucher !== null) {
            props.summaryStore.getSummary(props.summaryStore.contractCode, props.summaryStore.hardwareCode, props.summaryStore.nbnLocId, props.summaryStore.voipCode, props.saleStore.voucher.amount);
        }
    }, [props.saleStore.voucher]);
    var voucher = props.saleStore.voucher;
    var alert = voucher !== null &&
        (voucher.status !== 'ACTIVE'
            ? {
                dismissible: false,
                message: 'Invalid code. Please try again.',
                title: React.createElement(IconError, null),
                type: 'danger',
            }
            : {
                dismissible: false,
                message: "Your voucher code of $" + (voucher.amount / 100).toFixed(2) + " was applied.",
                title: React.createElement(IconGreenCheck, null),
                type: 'success',
            });
    function onApplyClick() {
        var tokenString = token.replace(/[-_]/g, '');
        if (tokenString.length === 16) {
            props.saleStore.isLoading(true);
            recaptcha.execute();
        }
        else {
            seterror({
                isValid: false,
                message: 'Voucher code must be 16 characters. Please try again.',
            });
        }
    }
    function applyPin() {
        return __awaiter(this, void 0, void 0, function () {
            var tokenParams, response, r, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokenParams = props.saleStore.voucherCode
                            .replace(/-/g, '')
                            .toLowerCase();
                        return [4, recaptcha.getResponse()];
                    case 1:
                        response = _a.sent();
                        props.saleStore.setRecaptchaResponse(response);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, axios({
                                headers: {
                                    recaptchaResponse: response,
                                },
                                method: 'get',
                                params: {
                                    code: tokenParams,
                                },
                                url: props.config.authEndPointUrl + "/anex-facade/vouchers",
                            })];
                    case 3:
                        r = _a.sent();
                        props.saleStore.setVoucher(r.data);
                        seterror(null);
                        props.saleStore.isLoading(false);
                        return [3, 5];
                    case 4:
                        e_1 = _a.sent();
                        seterror({
                            isValid: false,
                            message: 'Invalid voucher code. Please try again.',
                        });
                        props.saleStore.isLoading(false);
                        recaptcha.reset();
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    }
    return (React.createElement("div", { className: "form-group" },
        React.createElement("label", null, "Have a voucher code? Enter it below"),
        React.createElement("p", null,
            React.createElement("small", null,
                "Your voucher code will be on your Officeworks receipt. If you are having trouble finding your voucher code, please contact",
                ' ',
                React.createElement("a", { href: "tel:1300017150" }, "1300 OFFICE"),
                " for assistance.")),
        React.createElement("div", { className: "input-group" },
            React.createElement(InputMask, { placeholder: "Voucher code", className: "form-control", mask: "****-****-****-****", value: props.saleStore.voucherCode, disabled: voucher !== null && voucher.status === 'ACTIVE', onChange: function (e) {
                    settoken(e.currentTarget.value);
                    props.saleStore.setVoucherCode(e.currentTarget.value);
                } }),
            React.createElement("button", { type: "button", className: "btn btn-next btn-navy", disabled: token.length < 1 ||
                    (voucher !== null && voucher.status === 'ACTIVE'), onClick: onApplyClick }, "Apply")),
        error !== null &&
            (!error.isValid && (React.createElement(Alert, { dismissible: false, message: error.message, type: "danger", title: React.createElement(IconError, null) }))),
        voucher !== null &&
            (voucher.status === 'ACTIVE' && React.createElement(Alert, __assign({}, alert))),
        React.createElement(Recaptcha, { ref: function (ref) { return (recaptcha = ref); }, sitekey: props.config.googleRecaptchaKey, onResolved: applyPin, badge: "bottomleft" })));
}));
//# sourceMappingURL=VoucherCode.js.map